<template>
  <div class="web_index">
    <BaseHeader></BaseHeader>


    <div style="width: 100%;height: 80px"></div>
    <div class="web_content">
      <div class="address">
        <div style="width: 1140px;height: 40px;background-color: #444444"></div>
        <BMapComponent></BMapComponent>
        <div style="width: 1140px;height: 40px;background-color: #626262"></div>
      </div>
    </div>

      <component v-bind:is="'BaseBottom'"></component>
  </div>
</template>

<script>
    import BaseBottom from './BaseBottom.vue'
    import BaseHeader from './BaseHeader.vue'
    import router from '../../router'
    import BMapComponent from "./BMapComponent";
export default {
  name: 'Index',
  components: {BMapComponent:BMapComponent,BaseBottom: BaseBottom,BaseHeader},
  data () {
    return {
        jumpType:5
    }
  },
  methods: {

  },
  mounted :function() {

  },
    updated(){

    }
}
</script>


<style scoped="page">
  .web_index{
    width: 100%;
    background-color: #F0F4F5;
  }
  .web_title{
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 1000;
  }
  .web_title_content{
    width: 1290px;
    height: 80px;
    margin: auto;
    position: relative;
  }
  .title_img{
    margin-left: 40px;
    margin-top: 18px;
  }
  .title_content{
    height: 80px;
    position: absolute;
    right:45px;
    top: 0;
  }
  .title{
    float: right;
    height: 80px;
    line-height: 80px;
    font-size: 18px;
  }
  .title_red{
      float: right;
      height: 70px;
      line-height: 80px;
      font-size: 18px;
      border-bottom: 2px solid #cd001b;
      color: #000000;
  }
  .web_content{
    width: 1210px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 30px;
    padding-top: 92px;
    padding-bottom: 300px;
    background-color: #ffffff;
  }
  .address{
    width: 1140px;
    height: 420px;
    margin: auto;
      /*background-color: #0b0b0b;*/
      /*opacity:0.8;*/
  }

  .web_bottem{
    background-color: #2E3139;
    width: 100%;
    height: 120px;
    font-size: 16px;
    color: #C4C4C4;
    line-height: 120px;
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/web/Contact.vue